import { render } from "./CertificateEmptyState.vue?vue&type=template&id=88ced48a&scoped=true"
import script from "./CertificateEmptyState.vue?vue&type=script&lang=js"
export * from "./CertificateEmptyState.vue?vue&type=script&lang=js"

import "./CertificateEmptyState.vue?vue&type=style&index=0&id=88ced48a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88ced48a"]])

export default __exports__